import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import Wrp from "../../hoc/Wrp/Wrp";
import {isSet} from '../../Utils/CommonFunctions';
class Autocomplete extends Component {
  static propTypes = {
    suggestions: PropTypes.instanceOf(Array)
  };

  static defaultProps = {
    suggestions: []
  };

  constructor(props) {
    super(props);

    this.state = {
      // suggestions:this.props.suggestions,
      // The active selection's index
      activeSuggestion: 0,
      // The suggestions that match the user's input
      filteredSuggestions: [],
      // Whether or not the suggestion list is shown
      showSuggestions: false,
      // What the user has entered
      userInput: "",
      autoSet:false,
      isChanged:false,
      isSelected:false,
      isDisable:(this.props.isDisable)? this.props.isDisable : false
    };
  }
  
  componentDidUpdate = (prevProps)=> {
    if(prevProps.suggestions !== this.props.suggestions || prevProps.selectedValue !== this.props.selectedValue) {
      if(this.state.isChanged===false && this.state.isSelected===false){
        this.setState({
          // suggestions:this.props.suggestions,
          userInput:this.props.selectedValue,
          showSuggestions:false,
          filteredSuggestions:this.props.suggestions
        });
      }else{
        this.setState({
          // suggestions:this.props.suggestions,
          userInput:(this.props.selectedValue!==undefined && this.props.selectedValue!==null)?this.props.selectedValue:'',
          filteredSuggestions:this.props.suggestions,
          // showSuggestions:true,
        });
      }
      
    }
}

  // Event fired when the input value is changed
  onChange = e => {
    this.setState({isChanged:true})
    const { suggestions } = this.props;
    const userInput = e.currentTarget.value;
    this.props.search(userInput);
    // Filter our suggestions that don't contain the user's input
    // console.log('suggestions',suggestions);
    // const filteredSuggestions = isSet(suggestions,[]).filter((option,index)=>{
    //   if(option.label.toLowerCase().indexOf(userInput.toLowerCase()) > -1  || userInput===''){
    //     return option;
    //   }
    // });
    const filteredSuggestions = isSet(suggestions, []).filter((option, index) => {
      return option.label.toLowerCase().indexOf(userInput.toLowerCase()) > -1 || userInput === '';
    });
   
    // Update the user input and filtered suggestions, reset the active
    // suggestion and make sure the suggestions are shown
    this.setState({
      activeSuggestion: 0,
      filteredSuggestions,
      showSuggestions: true,
      userInput: e.currentTarget.value,
      autoSet:true,
    });
  };

  onClickHandlerFromSearch = (e) =>{
    // let userInput = e.target.value;
    // this.props.search(userInput);
      let filteredSuggestions = this.props.suggestions.filter((option,index)=>{
          // if(option.label.toLowerCase().indexOf(userInput.toLowerCase()) > -1){
            return option;
          // }
      });
      this.setState({
        isChanged:false,
        isSelected:false,
        showSuggestions:true,
        filteredSuggestions:filteredSuggestions
      });
  }
  // Event fired when the user clicks on a suggestion
  onSelectSuggestion = (selectedObj,wthis)=>{    
    this.setState({
      activeSuggestion: 0,
      filteredSuggestions: [],
      showSuggestions: false,
      userInput: selectedObj ? selectedObj.label : '',
      autoSet:false,
      isSelected:true,
    });
    this.props.select(selectedObj);
  } 
  
  
  outFocusHandler = ()=>{
    setTimeout(() => {
      this.setState({ showSuggestions: false});
    }, 500);
    
  }
  // Event fired when the user presses a key down
  onKeyDown = e => {
    const { activeSuggestion, filteredSuggestions } = this.state;

    // User pressed the enter key, update the input and close the
    // suggestions
    if (e.keyCode === 13) {
      this.props.select(filteredSuggestions[activeSuggestion]);
      this.setState({
        activeSuggestion: 0,
        showSuggestions: false,
        userInput: filteredSuggestions[activeSuggestion] ? filteredSuggestions[activeSuggestion].label : ''
      });
    }
    // User pressed the up arrow, decrement the index
    else if (e.keyCode === 38) {
      if (activeSuggestion === 0) {
        return;
      }

      this.setState({ activeSuggestion: activeSuggestion - 1 });
    }
    // User pressed the down arrow, increment the index
    else if (e.keyCode === 40) {
      if (activeSuggestion - 1 === filteredSuggestions.length) {
        return;
      }

      this.setState({ activeSuggestion: activeSuggestion + 1 });
    }
  };

  render() {
    const {
      onChange,
      // onClick,
      onKeyDown,
      state: {
        activeSuggestion,
        filteredSuggestions,
        showSuggestions,
        userInput
      }
    } = this;

    // const {isDisable} = this.state;

    // console.log(isDisable, this.props.isDisable, 'isDisableisDisable')
    // console.log('filteredSuggestions',filteredSuggestions,this.props.suggestions);
    let suggestionsListComponent;

    if (showSuggestions) {
      if (filteredSuggestions.length>0) {
        suggestionsListComponent = (
          <div className="autocomplete-items" key={filteredSuggestions.length}>
              <div
                  className={''}
                  key={'select'}
                  style={{fontSize:'13px',color:'#000'}}
                  onClick={this.onSelectSuggestion.bind(this,{})}>
                  {'-None-'}
              </div>
            {filteredSuggestions.map((suggestion, index) => {
              let className;
              // Flag the active suggestion with a class
              if (index === activeSuggestion) {
                className = "autocomplete-active";
              }
              return (
                <div
                  className={className}
                  key={index}
                  style={{fontSize:'13px',color:'#000'}}
                  onClick={this.onSelectSuggestion.bind(this,suggestion)}
                >
                  {suggestion.label}
                </div>
              );
            })}
            {(this.props.openQuickCreatePopup!==undefined)?
              <div className="no-suggestions" onClick={this.props.openQuickCreatePopup}><em>+Add New</em></div>
            :''}
          </div>
        );
      }else{
        suggestionsListComponent = (
          <div className="autocomplete-items">
            {(this.props.openQuickCreatePopup!==undefined)?
            <Wrp>
              <div className="no-suggestions" style={{backgroundColor:'#e3eff5',fontSize:'13px'}}><em>Not found..</em></div>
              <div className="no-suggestions" onClick={this.props.openQuickCreatePopup}><em>+Add New</em></div>
            </Wrp>
            :
            <div className="no-suggestions" style={{backgroundColor:'#e3eff5',fontSize:'13px'}}><em>Not found..</em></div>}
          </div>
        )
      // )
      }
      
    }
// console.log(userInput);
    return (
      <Fragment >
         {/* <form autoComplete="off"> */}

         {
          (this.props.isDisable && this.props.isDisable === true) ? 
          <input 
            type="text"
            autoComplete="new-suggestion"
            onChange={onChange}
            onKeyDown={onKeyDown}
            onBlur={this.outFocusHandler}
            onClick={e=>this.onClickHandlerFromSearch(e)}
            value={userInput}
            {...this.props.attributes}
            disabled="disabled"
          />
          :
          <>
          <input 
            type="text"
            autoComplete="new-suggestion"
            onChange={onChange}
            onKeyDown={onKeyDown}
            onBlur={this.outFocusHandler}
            onClick={e=>this.onClickHandlerFromSearch(e)}
            value={userInput}
            {...this.props.attributes}
          />
          {(this.props.isLoading===true && showSuggestions) &&
            <i
              className="fas fa-spinner fa-spin fa-lg"
              style={{
                position: "absolute",
                top: "35%",
                right: "60px", // Adjust based on your padding
                transform: "translateY(-50%)",
                color: "#000", // Customize loader color
                zIndex: '999'
              }}></i>
          }
          </>
         }

          
        {/* </form> */}
        {suggestionsListComponent}
      </Fragment>
    );
  }
}
//{...this.props.attributes}
Autocomplete.defaultProps = {
  isLoading:false
}
export default Autocomplete;